var React = require('react');

function Highway (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon-park:road"},React.createElement("g",{"id":"Group"},[React.createElement("path",{"id":"Vector","d":"M5.5 3L3 21","stroke":"#404040","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M18.5 3L20.9822 20.9776","stroke":"#404040","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"id":"Vector_3","d":"M12 3V6","stroke":"#404040","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"id":"Vector_4","d":"M12 17.5V21","stroke":"#404040","strokeLinecap":"round","strokeLinejoin":"round","key":3}),React.createElement("path",{"id":"Vector_5","d":"M12 10V13.5","stroke":"#404040","strokeLinecap":"round","strokeLinejoin":"round","key":4})])));
}

Highway.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Highway;

Highway.default = Highway;
